import React from 'react';
import './FormVoucherPurchase.scss';
import { Divider } from 'antd';
import { FormattedMessage } from 'react-intl';
import Button from 'Components/Shared/Button/Button';
import InputField from 'Components/Shared/InputField/InputField';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';
import WarningWrapper from 'Components/Shared/WarningWrapper/WarningWrapper';

interface IProps {
  amount: number;
  quantity: number;
  text: string;
  imageUrl: string;
  maxTotalValue: number;
  minTotalValue: number;
  isShowingWarningMinValue: boolean;
  isShowingWarningMaxValue: boolean;
  onQuantityChange: (value: number) => void;
  onAmountChange: (value: number) => void;
  onToPaymentClick: () => void;
}

const FormVoucherPurchase: React.SFC<IProps> = ({
  amount,
  quantity,
  text,
  imageUrl,
  maxTotalValue,
  minTotalValue,
  isShowingWarningMinValue,
  isShowingWarningMaxValue,
  onQuantityChange,
  onAmountChange,
  onToPaymentClick,
}) => {

  const warningElement = (
    isShowingWarningMaxValue ?
      <FormattedMessage 
        defaultMessage='Totalbeloppet är för högt'
        id= 'voucher.warning.maxvalue'
        values={ { maxValue: maxTotalValue } }
      /> :
      <FormattedMessage 
        defaultMessage='Totalbeloppet är för lågt'
        id= 'voucher.warning.minvalue'
        values={ { minValue: minTotalValue } }
      />
  );

  return (
    <div className='form-voucher-purchase'>
      <FormattedText 
        style='header'
        displayName='Köp presentkort'
        formattedName='voucher.buy'
      />
      <Divider />
      <div className='form-container'>
        { text && imageUrl && 
          <div className='left'>
            <div className='image-container'><img alt='Man med presentkort i bakfickan' src={ imageUrl } /></div>
            <div className='text' dangerouslySetInnerHTML={ { __html: text } } />
          </div>
        }
        <div className='right'>
          <div className='input-container'>
            <FormattedText 
              style='input-label' 
              displayName='Välj antal'
              formattedName='voucher.quantity'
            />
            <InputField
              type='number'
              required={ true }
              value={ quantity }
              onChange={ (e: React.FormEvent<HTMLInputElement>) => onQuantityChange(Number(e.currentTarget.value)) }
            />
          </div>
          <div className='input-container'>
            <FormattedText 
              style='input-label' 
              displayName='Belopp'
              formattedName='voucher.amount'
            />
            <InputField
              type='number'
              required={ true }
              value={ amount }
              onChange={ (e: React.FormEvent<HTMLInputElement>) => onAmountChange(Number(e.currentTarget.value)) }
            />
          </div>
          <WarningWrapper
            isShowingWarning={ isShowingWarningMinValue || isShowingWarningMaxValue }
            warningElement={ warningElement }
          >
            <Button color='purple' extraRadius={ true } onClick={ onToPaymentClick }>
              <FormattedText
                displayName='Till betalning'
                formattedName='order.button.payment'
              />
            </Button>
          </WarningWrapper>
        </div>
      </div>
      <Divider />
    </div>
  );
};

export default FormVoucherPurchase;


// WEBPACK FOOTER //
// ./src/components/FormVoucherPurchase/FormVoucherPurchase.tsx